import { useNavigate } from 'react-router-dom';
import type { Deal } from '@/types/deal';
import styles from './DealCard.module.css';

interface DealCardProps {
  deal: Deal;
}

export const DealCard = ({ deal }: DealCardProps) => {
  const navigate = useNavigate();

  return (
    <div className={styles.card} onClick={() => navigate(`/dashboard/deals/${deal.id}`)}>
      <div className={styles.title}>{deal.client_name}</div>
      {deal.notes && <div className={styles.notes}>{deal.notes}</div>}
      {(deal.event_date || deal.estimated_budget) && (
        <div className={styles.meta}>
          {deal.event_date && (
            <span className={styles.chip}>
              {new Date(deal.event_date).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
              })}
            </span>
          )}
          {deal.estimated_budget && (
            <span className={styles.chip}>
              {deal.currency} {Number(deal.estimated_budget).toLocaleString()}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
